// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: "Montserrat", sans-serif !important;
}

body {
  -webkit-font-smoothing: antialiased;
}

hr {
  height: 1px;
  background: #444343;
  border: none;
}

.dob-label {
  margin-top: 20px;
}

.top-label {
  color: #19608f;
  font-size: 1.2rem;
  font-weight: 600;
  padding: none;
}

.top-label-secondary-text {
  color: #19608f;
  margin-bottom: 15px;
  font-weight: 500;
}

.disabledColor {
  background: rgb(227, 227, 227);
  opacity: 0.6;
  color: black;
  font-weight: 600;
}

.gutter-80 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 80%;
}

.gutter-90 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 90%;
}

.grade-gutter-90 {
  max-width: 1800px;
  margin: 0 auto;
  width: 90%;
}
.grade-gutter-90 .will-be {
  text-decoration: underline;
}
.grade-gutter-90 .bold {
  font-weight: 650;
}
.grade-gutter-90 .yellow-box {
  border-radius: 4px;
  background: #FEBF31;
  padding: 3px 5px;
  font-weight: 600;
  color: black;
}

.out-of-bounds-container {
  display: flex;
  flex-direction: row;
  height: 500px;
  justify-content: center;
  width: 100%;
}
.out-of-bounds-container .out-of-bounds {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background: #D1D3D4;
  border: 2px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  height: 50%;
  padding: 50px;
  width: 80%;
}
.out-of-bounds-container hr {
  color: #444343;
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/global/Global.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AARA;EACI,gDAAA;AAWJ;;AAPA;EACI,mCAAA;AAUJ;;AARA;EACI,WAAA;EACA,mBDYK;ECXL,YAAA;AAWJ;;AATA;EACI,gBAAA;AAYJ;;AAVA;EACI,cDXM;ECYN,iBAAA;EACA,gBAAA;EACA,aAAA;AAaJ;;AAXA;EACI,cDjBM;ECkBN,mBAAA;EACA,gBAAA;AAcJ;;AAZA;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAeJ;;AAZA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAeJ;;AAbA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAgBJ;;AAbA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAgBJ;AAfI;EACI,0BAAA;AAiBR;AAfI;EACI,gBAAA;AAiBR;AAfI;ECxDA,kBDyD0B;EACtB,mBD5CI;EC6CJ,gBAAA;EACA,gBAAA;EACA,YAAA;AAiBR;;AAdA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAiBJ;AAhBI;ECtEA,mBDuE0B;EClD1B,2CAAA;EDoDI,mBAAA;EACA,mBD1DA;EC2DA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAkBR;AAhBI;EACI,cD9DC;EC+DD,UAAA;AAkBR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../../styles/global/Colors\";\n@import \"../../styles/global/globalMixins\";\n* {\n    font-family: \"Montserrat\", sans-serif !important;\n}\n\n// This is used for \"bolding\" text in chrome\nbody {\n    -webkit-font-smoothing: antialiased;\n}\nhr {\n    height: 1px;\n    background: $grey4a;\n    border: none;\n}\n.dob-label{\n    margin-top: 20px;\n}\n.top-label {\n    color: $dk-blue;\n    font-size: 1.2rem;\n    font-weight: 600;\n    padding: none;\n}\n.top-label-secondary-text {\n    color: $dk-blue;\n    margin-bottom: 15px;\n    font-weight: 500;\n}\n.disabledColor {\n    background: rgb(227, 227, 227);\n    opacity: .6;\n    color: black;\n    font-weight: 600;\n}\n\n.gutter-80 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 80%;\n}\n.gutter-90 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 90%;\n}\n\n.grade-gutter-90 {\n    max-width: 1800px;\n    margin: 0 auto;\n    width: 90%;\n    .will-be {\n        text-decoration: underline;\n    }\n    .bold {\n        font-weight: 650;\n    }\n    .yellow-box {\n        @include borderRadius(4px);\n        background: $important;\n        padding: 3px 5px;\n        font-weight: 600;\n        color: black;\n    }\n}\n.out-of-bounds-container {\n    display: flex;\n    flex-direction: row;\n    height: 500px;\n    justify-content: center;\n    width: 100%;\n    .out-of-bounds {\n        @include borderRadius(10px);\n        @include shadow();\n        align-items: center;\n        background: $grey1;\n        border: 2px solid $grey2;\n        display: flex;\n        flex-direction: column;\n        height: 50%;\n        padding: 50px;\n        width: 80%;\n    }\n    hr {\n        color: $grey4a;\n        width: 90%;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
